<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      max-height="540"
      border="none"
      :loading="loading"
      :data="invoiceListData"
      :auto-resize="true"
      align="center"
      :footer-method="footerMethod"
      @filter-change="filterTypeMethod"
      @cell-click="cellClick"
      ref="xTable"
    >
      <vxe-table-column type="seq" title="序号" width="90">
        <template slot-scope="{ row, $rowIndex }">
          <span>{{ $rowIndex + 1 }}</span>
          <Dropdown trigger="click" style="margin-left: 20px" transfer>
            <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
            <DropdownMenu slot="list" style="left: 70px">
              <div style="display: flex; flex-direction: column">
                <Button class="button-gengduo" @click="confirmEvent(row.id)"
                  >移除进项发票
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="invoiceNum"
        title="发票编号"
        width="120"
        class-name="link-text"
      ></vxe-table-column>
      <vxe-table-column field="flowNum" title="流程编号" width="130">
        <template slot-scope="{ row }">
          <span
            @click="openProcedureDetail(row.flowId, 2)"
            style="color: #2d8cf0; cursor: pointer"
            >{{ row.flowNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="addTime"
        title="开票日期"
        width="100"
      ></vxe-table-column>
      <vxe-table-column
        field="invoiceType"
        title="发票类型"
        width="120"
      ></vxe-table-column>
      <vxe-table-column
        field="invoiceCompName"
        title="开票企业名称"
        :filters="filterInvoiceCompName"
        width="180"
      ></vxe-table-column>
      <vxe-table-column
        field="invoiceTitle"
        :filters="filterInvoiceTitle"
        title="发票抬头"
        width="200"
      ></vxe-table-column>
      <vxe-table-column
        field="goodsName"
        title="应税商品名称"
        width="150"
      ></vxe-table-column>
      <vxe-table-column
        field="counts"
        title="数量"
        width="75"
      ></vxe-table-column>
      <vxe-table-column field="unit" title="单位" width="75"></vxe-table-column>
      <vxe-table-column field="price" title="单价" width="75">
        <template slot-scope="{ row }">
          <span>{{ row.price | numberToCurrency }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="taxRate"
        title="税率（%）"
        width="100"
      ></vxe-table-column>
      <vxe-table-column field="taxAmount" title="税额（元）" width="150">
        <template slot-scope="{ row }">
          <span>{{ row.taxAmount | numberToCurrency }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="taxTotalAmount"
        title="价税合计（元）"
        width="180"
      >
        <template slot-scope="{ row }">
          <span>{{ row.taxTotalAmount | numberToCurrency }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="note"
        title="备注信息"
        width="100"
      ></vxe-table-column>
      <vxe-table-column
        field="carShipNum"
        title="车船号"
        width="100"
      ></vxe-table-column>
      <vxe-table-column
        field="beginPlace"
        title="起运地"
        width="100"
      ></vxe-table-column>
      <vxe-table-column
        field="endPlace"
        title="目的地"
        width="100"
      ></vxe-table-column>
      <vxe-table-column
        field="laydays"
        title="受载/交接日期"
        width="150"
      ></vxe-table-column>
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page.sync="page.currentPage"
      :page-size.sync="page.pageSize"
      :total="page.totalResult"
      @page-change="handlePageChange"
    ></vxe-pager>

    <vxe-modal
        v-model="isShowInvoiceDetail"
        title="发票详情"
        width="1200"
        height="920"
        position="center"
        resize
        remember
    >
      <detail ref="detail" :cate="'Income'" @close="isShowInvoiceDetail = false" @init="init"></detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { timeFormatDate } from "@/filters/time";
import { invoiceMap, numberToCurrency } from "@/filters/type";
import Detail from "@/views/invoice/Detail";
import { invoiceFooter, getFilterObj } from "@/utils/util";
import openProcedureDetail from "@/mixin/viewOrderDetail";
import getAuthOrization from "@/mixin/getAuthOrization";

// 进项发票
export default {
  components: {
    Detail,
  },
  props: {
    id: Number,
    pageTab: String,
  },
  mixins: [getAuthOrization,openProcedureDetail],
  data() {
    return {
      loading: false,
      invoiceListData: [],
      invoiceCompName:null,
      invoiceTitle:null,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      countRtnVo: {},

      isShowInvoiceDetail: false,
      filterInvoiceCompName: [],
      filterInvoiceTitle: [],
    };
  },
  watch: {
    // id(nv, ov) {
    //   if (nv !== ov && nv !== undefined) {
    //     this.getInvoiceListData();
    //   }
    // },
    pageTab() {
      this.pageTab === "tab6" ? this.getInvoiceListData() : "";
    },
  },
  // activated() {
  //   // this.getInvoiceListData();
  //   this.$bus.$on("allOrderDetailRenovate", (data) => {
  //     data === true ? this.getInvoiceListData() : "";
  //   });
  // },
  methods: {
    init() {
      this.getInvoiceListData();
    },
    filterTypeMethod({ column, property, values, datas, filters, $event }) {
      this.page.currentPage = 1;
      if (values.length > 0) {
        if (property == "invoiceTitle"){
          this.invoiceTitle = values;
        }
        else if (property == "invoiceCompName"){
          this.invoiceCompName = values;
        }
      } else {
        this.invoiceTitle = null;
        this.invoiceCompName = null;
      }
      this.getInvoiceListDataFilter();
    },
    async getInvoiceListDataFilter() {
      this.loading = true;
      let res = await $api.invoice.request("queryInvoiceBuyerListSelect", {
        chainId: this.id,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
        invoiceTitle:this.invoiceTitle,
        invoiceCompName:this.invoiceCompName
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.countRtnVo = res.data.countRtnVo;
        let invoiceListData = res.data.rows;
        this.invoiceListData = invoiceListData;
        invoiceListData.map((i) => {
          i.addTime = timeFormatDate(i.addTime);
          i.laydays = timeFormatDate(i.laydays);
          i.invoiceType = invoiceMap(i.invoiceType);
        });
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getInvoiceListData() {
      this.filterInvoiceCompName = [];
      this.filterInvoiceTitle = [];
      this.loading = true;
      let res = await $api.invoice.request("queryInvoiceBuyerListSelect", {
        chainId: this.id,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
        invoiceTitle:this.invoiceTitle,
        invoiceCompName:this.invoiceCompName
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.countRtnVo = res.data.countRtnVo;
        let invoiceListData = res.data.rows;
        const xTable = this.$refs.xTable;
        const invoiceCompNameColumn = xTable.getColumnByField(
          "invoiceCompName"
        );
        const invoiceTitleColumn = xTable.getColumnByField("invoiceTitle");
        // console.log(invoiceListData, "invoiceListData");
        invoiceListData.map((i) => {
          getFilterObj(this.filterInvoiceCompName, i.invoiceCompName);
          getFilterObj(this.filterInvoiceTitle, i.invoiceTitle);
          i.addTime = timeFormatDate(i.addTime);
          i.laydays = timeFormatDate(i.laydays);
          i.invoiceType = invoiceMap(i.invoiceType);
        });
        xTable.setFilter(invoiceCompNameColumn, this.filterInvoiceCompName);
        xTable.setFilter(invoiceTitleColumn, this.filterInvoiceTitle);
        xTable.updateData();
        this.invoiceListData = invoiceListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async confirmEvent(id) {
      let confirmRes = await this.$XModal.confirm(
        "删除后，将解除此订单关联的发票信息",
        "是否删除此发票？"
      );
      if (confirmRes === "confirm") {
        let res = await $api.invoice.request("updateInvoiceBuyerUnbind", {
          id,
        });
        if (res.status === 1) {
          this.$XModal.message({ message: `删除成功！` });
          this.getInvoiceListData();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      // 分页
      this.page.currentPage = currentPage;
      this.page.pageSize = pageSize;
      this.getInvoiceListDataFilter();
    },
    footerMethod({ columns, data }) {
      return invoiceFooter({ columns, data, countRtnVo: this.countRtnVo });
    },
    cellClick(e) {
      let field = e.column.property;
      if (field == "invoiceNum") {
          if (!this.isHavePermission('invoiceBuyer:detail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
        }
        this.isShowInvoiceDetail = true;
        this.$refs.detail.setEdit(false);
        this.$refs.detail.init(e.row);
      }
    },
  },
};
</script>

<style>
</style>